import { IonicModule } from '@ionic/angular';
// Angular Imports
import { NgModule } from '@angular/core';

// This Module's Components
import { HelpButtonComponent } from './help-button.component';

@NgModule({
  imports: [IonicModule],
  declarations: [HelpButtonComponent],
  exports: [HelpButtonComponent],
})
export class HelpButtonModule {}
